import { render } from "./newProducts.vue?vue&type=template&id=3b4a89e7"
import script from "./newProducts.vue?vue&type=script&lang=js"
export * from "./newProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__